import { render, staticRenderFns } from "./r-search-table.vue?vue&type=template&id=21813a20"
import script from "./r-search-table.vue?vue&type=script&lang=js"
export * from "./r-search-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21813a20')) {
      api.createRecord('21813a20', component.options)
    } else {
      api.reload('21813a20', component.options)
    }
    module.hot.accept("./r-search-table.vue?vue&type=template&id=21813a20", function () {
      api.rerender('21813a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/search/r-search-table.vue"
export default component.exports